import { FormikErrors } from 'formik';

import { translate } from '../../../common/helpers/translate.helper';

import { FormikAssignmentState } from './AssignmentBaseForm';

export const validateAssignment = (values: FormikAssignmentState): FormikErrors<FormikAssignmentState> => {
    const errors: FormikErrors<FormikAssignmentState> = {};

    if (!values.customerId) {
        errors.customerId = translate('assignments.customerRequired');
    }

    if (!values.supplierId) {
        errors.supplierId = translate('assignments.supplierRequired');
    }

    return errors;
};
